import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue'
import {
  ToolsService,
  AppType,
  MunicipalEntitiesService,
  ConnectionStatusService,
  Permissions,
  hasUserPermission,
  AppAuthService,
} from '@prodcard/core'
import { createCtx } from '../../../helpers'
import ExportTab from './ExportTab.vue'
import ImportTab from './ImportTab.vue'
import { refObservableValue } from '@prodcard/apps-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolsPage',
  props: {
    toolsService: {},
    authService: {},
    municipalEntitiesService: {},
    connectionStatusService: {}
  },
  setup(__props: any) {

const props = __props;



const currentUserPermissions = refObservableValue(props.authService.permissions)
const canExport = computed(() => {
  return hasUserPermission(currentUserPermissions.value, Permissions.TOOLS_EXPORT_VIEW)
})
const canImport = computed(() => {
  return hasUserPermission(currentUserPermissions.value, Permissions.TOOLS_IMPORT_VIEW)
})

const currentAppType = props.toolsService.currentAppType(createCtx())
const tab = ref(0)

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_tabs, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
      color: "primary",
      "align-tabs": "start"
    }, {
      default: _withCtx(() => [
        (canExport.value)
          ? (_openBlock(), _createBlock(_component_v_tab, {
              key: 0,
              value: "export"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Выгрузить данные")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(currentAppType) === _unref(AppType).DESKTOP && canImport.value)
          ? (_openBlock(), _createBlock(_component_v_tab, {
              key: 1,
              value: "import"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Загрузить данные")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_card, { class: "mt-5" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
          class: "pa-5"
        }, {
          default: _withCtx(() => [
            (canExport.value)
              ? (_openBlock(), _createBlock(_component_v_window_item, {
                  key: 0,
                  value: "export"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ExportTab, {
                      "tools-service": _ctx.toolsService,
                      "auth-service": _ctx.authService,
                      "municipal-entities-service": _ctx.municipalEntitiesService,
                      "connection-status-service": _ctx.connectionStatusService
                    }, null, 8, ["tools-service", "auth-service", "municipal-entities-service", "connection-status-service"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (canImport.value)
              ? (_openBlock(), _createBlock(_component_v_window_item, {
                  key: 1,
                  value: "import"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ImportTab, { "tools-service": _ctx.toolsService }, null, 8, ["tools-service"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ], 64))
}
}

})